var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-0 px-0 briefs "},[_c('span',{staticClass:" "},[_c('span',{staticClass:"svg-icon svg-icon-md svg-icon-danger",on:{"click":_vm.view}},[_c('inline-svg',{attrs:{"src":"media/svg/icons/Files/icon_brief.svg"}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }